import styled from "styled-components"
import Colors from "../../theme/colors"

interface Props {
  marginBottom?: number
}

const Divider = styled.hr<Props>`
  background: ${Colors.lightGreyFaded};
  opacity: 0.5;
  ${props => props.marginBottom && `margin-bottom: ${props.marginBottom}px`}
`

export default Divider
